module.exports = __webpack_public_path__ + "static/img/roleInfo.12bbe8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/role/character_3/roleInfo.png
// module id = x8Z4
// module chunks = 1